import type { PropsWithChildren } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface ColumnProps {
  className?: string;
  dataTestId?: string;
  wrapperClassName?: string;
}

export const Column = ({
  children,
  className,
  wrapperClassName,
  dataTestId,
}: PropsWithChildren<ColumnProps>) => (
  <div className={classNames("w-full", className)} data-testid={dataTestId}>
    <div className={classNames("w-full sm:max-w-[540px]", wrapperClassName)}>
      {children}
    </div>
  </div>
);
